import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  host: z.string().min(1, t('pages.communication_central.components.smtp_config_tab.schema.required')),
  username: z.string().min(1, t('pages.communication_central.components.smtp_config_tab.schema.required')),
  password: z.string().min(1, t('pages.communication_central.components.smtp_config_tab.schema.required')),
  port: z.number().min(1, t('pages.communication_central.components.smtp_config_tab.schema.required')),
  from: z.string().min(1, t('pages.communication_central.components.smtp_config_tab.schema.required')),
  reply_to: z.string().min(1, t('pages.communication_central.components.smtp_config_tab.schema.required')),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
